import { IconItem } from './icon.definitions';

export class ChipButtonSelectData<T> {
    Value!: T;
    Label: string = "";
    HintMessage: string | null = null;
    IconName: IconItem | null = null;
}
export class ChipDateRangeSelectData {
    Label: string = "";
    DateRange!: [string, string]; // end date is inclusive
}

export class ChipTimeChipPickerLabels {
    StartLabel: string = "";
    StartHelperText: string = "";
    EndLabel: string = "";
    EndHelperText: string = "";
    Title: string = "";
}
